<template>
  <page>
    <div>
      <v-flex xs12>
        <form action="">
          <v-expansion-panels>
          <v-expansion-panel>
              <v-expansion-panel-header>
              <div>
                <v-icon>mdi-filter-variant</v-icon> Filters
              </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
              <v-card>
                <v-card-text>
                  <v-container fluid grid-list-lg>
                    <v-layout row wrap>
                      <v-flex md6>
                        <v-text-field v-model="filters.ttyNo" :label="labels.ttyNo" :error-messages="errors.collect('ttyNo')" data-vv-name="ttyNo" :data-vv-as="labels.ttyNo" v-validate="'name|max:8'"></v-text-field>
                      </v-flex>
                      <v-flex md6>
                        <v-text-field v-model="filters.uwYr" :label="labels.uwYr" :error-messages="errors.collect('uwYr')" data-vv-name="uwYr" :data-vv-as="labels.uwYr" v-validate="'mask_decimal:0|mask_min_value:1'"></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                  <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                </v-card-actions>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        </form>
      </v-flex>
      <v-spacer class="mt-2"></v-spacer>
      <v-card>
        <v-flex xs12>
          <message :messages="messages"></message>
        </v-flex>
        <!-- <v-card-title>
          <v-layout row wrap>
            <v-spacer></v-spacer>
            <v-btn class=" mr-2" color="primary" dark @click="doNewTreaty">
              New Treaty Parameters
              <v-icon right>mdi-plus</v-icon>
            </v-btn>
            <download-csv :data="items" name="TreatyParamList.csv">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn class="mx-2" fab dark small color="primary" v-on="on">
                    <v-icon dark>mdi-download</v-icon>
                  </v-btn>
                </template>
                <span>Download CSV</span>
              </v-tooltip>
            </download-csv>
          </v-layout>
        </v-card-title> -->
        <v-flex xs12>
          <v-card>
            <v-data-table :headers="headers" :items="items" v-bind:options.sync="pagination" :server-items-length="totalItems" :loading="loading" :footer-props="{'items-per-page-options': itemsPerPage }" :no-data-text="noDataText">
              <template v-slot:item="row"><tr>
                <td class="text-xs-left">{{ row.item.riType }}</td>
                <td class="text-xs-left">{{ row.item.ttyNo }}</td>
                <td class="text-xs-left">{{ row.item.ttyName }}</td>
                <td class="text-xs-left">{{ row.item.ttyType }}</td>
                <td class="text-xs-left">{{ formatDisplayDate(row.item.comDate) }}</td>
                <td class="text-xs-left">{{ formatDisplayDate(row.item.expDate) }}</td>
                <td class="text-xs-left">{{ row.item.uwYr }}</td>
                <td class="table-action-header">
                  <table-action :rowData="row" review @review="doTreatyReview(row.item)" remove @remove="doPromptRemove(row.item)"></table-action>
                </td>
              </tr></template>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-card>
      <confirm v-model="promptRemove" @ok="doRemove">
        Are you sure to delete the selected Accumulation Type {{ deleteTreaty }}
      </confirm>
    </div>
  </page>
</template>
<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { formatDisplayDate, formatDisplayDateTime2, removeTime } from '@/utils/date'
import { expandURI, filterQuery } from '@/utils/ajax'
import clone from 'clone'
export default {
  data() {
    return {
      toogleArray: [false],
      headers: [
        { text: 'RI Type ', value: 'riType' },
        { text: 'Treaty No. ', value: 'ttyNo' },
        { text: 'Treaty Name ', value: 'ttyName' },
        { text: 'Treaty Type', value: 'ttyType' },
        { text: 'Com Date ', value: 'comDate' },
        { text: 'Expiry Date', value: 'expDate' },
        { text: 'Underwriting Year', value: 'uwYr' },
        TableConst.tableActionHeader
      ],
      labels: {
        ttyNo: 'Treaty No. ',
        ttyDesc: 'Treaty Name ',
        ttyType: 'Treaty Type',
        effDate: 'Effective Date',
        expDate: 'Expiry Date',
        uwYr: 'Underwriting Year'
      },
      filters: {
        ttyNo: undefined,
        uwYr: undefined
      },
      promptRemove: false,
      loading: false,
      deleteTreaty: '',
      selectedTreaty: undefined,
      totalItems: 0,
      listItems: [],
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  watch: {
    'pagination': function (value) {
      this.doInit(false)
    }
  },
  methods: {
    formatDisplayDate(xDate) {
      return formatDisplayDate(xDate)
    },
    async doInit(options) {
      this.resetMessages()
      const apiURI = this.menu.getTreatyDetList
      if (apiURI) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: itemsPerPage,
            options: options
          }
          let currFilters = clone(this.filters)
          if (currFilters.effDate) {
            currFilters.effDate = formatDisplayDateTime2(removeTime(currFilters.effDate))
          }
          if (currFilters.expDate) {
            currFilters.expDate = formatDisplayDateTime2(removeTime(currFilters.expDate))
          }
          const result = await this.$http.get(filterQuery(expandURI(apiURI, expand), currFilters, this.pagination.sortBy, this.pagination.sortDesc))
          if (result) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            this.items = []
            if (data) {
              data.map((treatyDetMap) => {
                const convertList = {
                  riType: treatyDetMap.riType,
                  ttyNo: treatyDetMap.ttyNo,
                  ttyName: treatyDetMap.ttyName,
                  ttyType: treatyDetMap.ttyType,
                  noFormatcomDate: treatyDetMap.comDate,
                  noFormatExpDate: treatyDetMap.expDate,
                  comDate: treatyDetMap.comDate,
                  expDate: treatyDetMap.expDate,
                  uwYr: treatyDetMap.uwYr
                }
                this.items.push(convertList)
              })
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      }
    },
    doClearFilters() {
      this.resetMessages()
      this.filters.ttyNo = null
      this.filters.uwYr = null
      this.pagination.page = 1
      this.doInit(false)
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.pagination.page = 1
          this.doInit(false)
        }
      })
    },
    doNewTreaty(modeTreaty) {
      this.$router.push({ name: 'treatyParamsReview', params: { ttyNoParam: 'New', modeTreaty: 'Create' } })
    },
    doTreatyQuery(ttyNoParam, modeTreaty) {
      this.$router.push({ name: 'treatyParamsReview', params: { ttyNoParam: ttyNoParam, modeTreaty: 'Query' } })
    },
    doTreatyReview(ttyNoParam) {
      this.$router.push({ name: 'treatyRI', params: { riType: ttyNoParam.riType, ttyNo: ttyNoParam.ttyNo, uwYr: ttyNoParam.uwYr } })
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedTreaty = data
        this.deleteTreaty = data.ttyNo
      }
    },
    async doRemove() {
      const apiURI = this.menu.deleteTreaty
      if (apiURI) {
        const expand = this.selectedTreaty
        this.$http
          .post(apiURI, expand)
          .then((result) => {
            const data = result.data
            this.notify(data)
            this.doInit(true)
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
            }
          })
      }
    }
  },
  computed: {
    menu() {
      return this.$store.state.treatyParam.menu
    },
    expDateValidation() {
      if (this.filters.expDate !== undefined && this.filters.expDate !== '') {
        return 'entry|start_enddate:' + this.filters.effDate
      } else {
        return ''
      }
    }
  },
  created() {
    // this.doInit()
  },
  mounted() {},
  filters: {
    formatDate(value) {
      return formatDisplayDate(value)
    }
  },
  mixins: [TableConst.default, MessageMixin]
}
</script>
